import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { BiSearch, BiPlus } from "react-icons/bi";
import { RadioGroup } from "@headlessui/react";
import { Button } from "../Form";
import axiosInstance from "../../api/axiosConfig"; // Direct axios for users
import medicineService from "../../api/medicineService";
import servicesService from "../../api/servicesService";
import { toast } from "react-hot-toast";

function PatientMedicineServiceModal({ closeModal, isOpen, patient, onSelect }) {
  const [selected, setSelected] = useState(null);
  const [datas, setDatas] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      if (patient) {
        // Fetch Patients
        const res = await axiosInstance.get("/user/patients");
        // Check structure. Controller 'getPatientsForUser' likely returns array or {success, data}
        // Assuming { success: true, data: [...] } or just array
        const list = res.data.data || res.data;
        setDatas(list.map(u => ({ ...u, title: u.fullName, id: u._id })));
      } else {
        // Fetch Medicines & Services
        const [medRes, servRes] = await Promise.all([
          medicineService.getAllMedicines(search),
          servicesService.getAllServices(search)
        ]);

        const meds = (medRes.data || []).map(m => ({ ...m, type: 'Medicine', title: m.name, price: m.price }));
        const servs = (servRes.data || []).map(s => ({ ...s, type: 'Service', title: s.name, price: s.price }));

        setDatas([...meds, ...servs].sort((a, b) => a.title > b.title ? 1 : -1));
      }
    } catch (error) {
      toast.error("Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, patient, search]);

  const handleAdd = () => {
    if (!selected) return toast.error("Please select an item");
    onSelect(selected);
    closeModal();
  };

  return (
    <Modal
      closeModal={closeModal}
      isOpen={isOpen}
      title={patient ? "Patients" : "Medicine & Services"}
      width={"max-w-xl"}
    >
      <div className='flex-colo gap-6'>
        {/* search */}
        <div className='flex w-full items-center gap-4 rounded-lg border border-border p-3'>
          <input
            type='text'
            placeholder='Search'
            className='w-full'
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <BiSearch className='text-xl' />
        </div>

        {/* data */}
        <div className='h-[500px] w-full overflow-y-scroll'>
          {loading ? (
            <p className="text-center p-4">Loading...</p>
          ) : (
            <RadioGroup value={selected} onChange={setSelected}>
              <div className='space-y-2'>
                {datas.map((user) => (
                  <RadioGroup.Option
                    key={user.id}
                    value={user}
                    className={({ active, checked }) =>
                      ` ${active || checked ? "border-subMain bg-subMain text-white" : ""} group rounded-xl border-[1px] border-border p-4 hover:bg-subMain hover:text-white cursor-pointer`
                    }
                  >
                    {({ active, checked }) => (
                      <>
                        <h6 className='text-sm'>
                          {user.title || user.name}
                          {!patient && <span className="ml-2 text-xs opacity-70">({user.type}) - {user.price} Tsh</span>}
                        </h6>
                        {patient && (
                          <p
                            className={`${(active || checked) && "text-white"
                              } mt-1 text-xs text-textGray group-hover:text-white`}
                          >
                            {user.email}
                          </p>
                        )}
                      </>
                    )}
                  </RadioGroup.Option>
                ))}
              </div>
            </RadioGroup>
          )}
        </div>
        {/* button */}

        <Button onClick={handleAdd} label='Add' Icon={BiPlus} />
      </div>
    </Modal>
  );
}

export default PatientMedicineServiceModal;